/**
 * Frontend → edge correlation header helper.
 *
 * Every outbound fetch to a Supabase Edge Function should pass the value
 * returned by `nextCorrelationId()` as `x-correlation-id`. The edge logger
 * (`EdgeFunctionLogger`) honors the incoming header, so a single id stitches
 * together a frontend Logz.io entry, an edge Logz.io entry, and a Sentry
 * issue across both projects.
 *
 * Shape: `<tabId>-<uuid-fragment>` — the `tabId` prefix makes it trivial to
 * filter every call from a given browser tab.
 */

import { tabId } from "@/lib/frontend-logger";

export const CORRELATION_HEADER = "x-correlation-id";

export function nextCorrelationId(): string {
  const suffix = crypto.randomUUID().slice(0, 8);
  return `${tabId.slice(0, 8)}-${suffix}`;
}